export default __webpack_public_path__ + "static/media/cat2.e353f5ed.webp";